import React from 'react';
import { DropdownMenu, DropdownMenuPlacements, Pill, PillShapes, PillTones } from '@clockout-dev/design-elements';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { PAYROLL_SOURCES_POPOVER_WIDTH } from '../user.constants';
import styles from './styles/user-header.module.scss';

/**
 * The "Riverside Logistics +1 ⌄" trigger and its sources popover (Figma
 * «Employer popover», 296:22221). Built on the DS DropdownMenu: its header
 * and item (label / description / trailing Pill) slots are exactly the
 * popover's title and rows. Figma's "View payroll data" footer link waits on
 * the Payroll data tab and is not built.
 *
 * Controlled: the rows (`UserHeaderController.toPayrollSourceMenuItems`) and
 * the open state (`payrollSourcesOpen`, set through UserDelegate) come from
 * the page.
 *
 * @param {Object} props
 * @param {string | null} props.employer Leading employer text.
 * @param {string} props.title Popover caption ("2 Payroll sources").
 * @param {Array<Object>} props.items DropdownMenu items; may be empty while loading.
 * @param {number} props.count Total sources (drives "+N").
 * @param {boolean} [props.open]
 * @param {(next: boolean, info?: Object) => void} [props.onOpenChange]
 */
function PayrollSourcesPopover({ employer, title, items, count, open = false, onOpenChange }) {
    const extra = Math.max(count - 1, 0);
    const Chevron = open ? ChevronUpIcon : ChevronDownIcon;

    return (
        <DropdownMenu
            open={open}
            onOpenChange={onOpenChange}
            disabled={items.length === 0}
            placement={DropdownMenuPlacements.BOTTOM_LEFT}
            width={PAYROLL_SOURCES_POPOVER_WIDTH}
            classNames={{ panel: styles.sourcesPanel }}
            header={title}
            items={items}
        >
            <button type="button" className={styles.sourcesTrigger}>
                {employer ? <span className={styles.metaText}>{employer}</span> : null}
                <Pill tone={PillTones.BRAND} shape={PillShapes.BADGE} label={`+${extra}`} />
                <Chevron className={styles.inlineIcon} aria-hidden="true" />
            </button>
        </DropdownMenu>
    );
}

export default PayrollSourcesPopover;
